export default {
    topics: [
        {
            title: ' CreateInstance ',
            href: 'sm-remoteTracking-CreateInstance.html',
            attributes: { 'data-id': 'sm-remoteTracking-CreateInstance' },
            menu: { hasChildren: false },
            tocID: 'sm-remoteTracking-CreateInstance-d66e3711',
            topics: [],
        },
        {
            title: ' CreateInstanceEx ',
            href: 'sm-remoteTracking-CreateInstanceEx.html',
            attributes: { 'data-id': 'sm-remoteTracking-CreateInstanceEx' },
            menu: { hasChildren: false },
            tocID: 'sm-remoteTracking-CreateInstanceEx-d66e3719',
            topics: [],
        },
        {
            title: ' GetTrackingInfo ',
            href: 'sm-remoteTracking-GetTrackingInfo.html',
            attributes: { 'data-id': 'sm-remoteTracking-GetTrackingInfo' },
            menu: { hasChildren: false },
            tocID: 'sm-remoteTracking-GetTrackingInfo-d66e3727',
            topics: [],
        },
        {
            title: ' GetTrackingLogs ',
            href: 'sm-remoteTracking-GetTrackingLogs.html',
            attributes: { 'data-id': 'sm-remoteTracking-GetTrackingLogs' },
            menu: { hasChildren: false },
            tocID: 'sm-remoteTracking-GetTrackingLogs-d66e3735',
            topics: [],
        },
        {
            title: ' GetTrackingLogs4 ',
            href: 'sm-remoteTracking-GetTrackingLogs4.html',
            attributes: { 'data-id': 'sm-remoteTracking-GetTrackingLogs4' },
            menu: { hasChildren: false },
            tocID: 'sm-remoteTracking-GetTrackingLogs4-d66e3743',
            topics: [],
        },
        {
            title: ' PushRelayInfo ',
            href: 'sm-remoteTracking-PushRelayInfo.html',
            attributes: { 'data-id': 'sm-remoteTracking-PushRelayInfo' },
            menu: { hasChildren: false },
            tocID: 'sm-remoteTracking-PushRelayInfo-d66e3751',
            topics: [],
        },
        {
            title: ' PushTrackingInfo ',
            href: 'sm-remoteTracking-PushTrackingInfo.html',
            attributes: { 'data-id': 'sm-remoteTracking-PushTrackingInfo' },
            menu: { hasChildren: false },
            tocID: 'sm-remoteTracking-PushTrackingInfo-d66e3759',
            topics: [],
        },
        {
            title: ' RegisterInstance ',
            href: 'sm-remoteTracking-RegisterInstance.html',
            attributes: { 'data-id': 'sm-remoteTracking-RegisterInstance' },
            menu: { hasChildren: false },
            tocID: 'sm-remoteTracking-RegisterInstance-d66e3767',
            topics: [],
        },
    ],
};

